/* Misty Lorette Heritage 4.1.5 compatibility layer.
   Keeps custom selector hooks resilient while Heritage core remains vendor-owned. */

(() => {
  const productKits = new Set(['eclipse-ritual-kit', 'midnight-eclipse-kit']);

  const ensureStickyStyles = () => {
    if (document.getElementById('ml-415-sticky-compat')) return;
    const style = document.createElement('style');
    style.id = 'ml-415-sticky-compat';
    style.textContent = `
      @media screen and (max-width: 749px) {
        .sticky-add-to-cart__bar {
          bottom: 0 !important;
          width: 100% !important;
          max-width: none !important;
          border-radius: 0 !important;
          padding-bottom: max(var(--padding-sm), env(safe-area-inset-bottom)) !important;
        }
        .sticky-add-to-cart__bar .add-to-cart-text__content {
          display: inline !important;
          white-space: nowrap;
        }
        .sticky-add-to-cart__bar .add-to-cart-text > .svg-wrapper {
          display: none !important;
        }
        .sticky-add-to-cart__button {
          width: auto !important;
          min-width: 92px;
          padding-inline: var(--padding-md) !important;
        }
        sticky-add-to-cart:not([data-variant-available='true']) .sticky-add-to-cart__button {
          width: auto !important;
        }
        shopify-chat::part(activator) {
          transition: transform 0.25s var(--ease-out-quad);
        }
        html.ml-sticky-cart-visible shopify-chat::part(activator) {
          transform: translateY(-84px);
        }
      }
    `;
    document.head.appendChild(style);
  };

  const pathHandle = (segment) => {
    const marker = `/${segment}/`;
    const index = window.location.pathname.indexOf(marker);
    if (index === -1) return '';
    return decodeURIComponent(window.location.pathname.slice(index + marker.length).split('/')[0] || '');
  };

  const decorateCollection = () => {
    const handle = pathHandle('collections');
    if (!handle) return;

    document.querySelectorAll('.product-grid-container').forEach((container) => {
      container.classList.add('ml-collection-products');
      container.classList.add(`ml-collection-products--${handle}`);
    });
  };

  const decorateProductGallery = () => {
    const handle = pathHandle('products');
    if (!handle) return;

    document.querySelectorAll('.product-information media-gallery').forEach((gallery) => {
      if (productKits.has(handle)) gallery.classList.add('ml-media-gallery--kits-sets');
      if (handle === 'sapphire-siren-strappy-satin-garter-set') {
        gallery.classList.add('ml-media-gallery--sapphire-siren');
      }

      const mediaItems = gallery.querySelectorAll('zoom-dialog .product-media-container');
      const thumbnails = gallery.querySelectorAll('zoom-dialog .dialog-thumbnails-list__thumbnail');

      thumbnails.forEach((thumbnail, index) => {
        const media = mediaItems[index];
        if (!media) return;

        const isVideo = media.classList.contains('product-media-container--video') ||
          media.classList.contains('product-media-container--external_video');
        if (!isVideo) return;

        thumbnail.classList.add(
          media.classList.contains('product-media-container--external_video')
            ? 'dialog-thumbnail--external_video'
            : 'dialog-thumbnail--video'
        );

        if (thumbnail.querySelector('.ml-dialog-thumbnail__play')) return;
        const play = document.createElement('span');
        play.className = 'ml-dialog-thumbnail__play';
        play.setAttribute('aria-hidden', 'true');
        play.innerHTML = '<svg viewBox="0 0 12 14" aria-hidden="true" focusable="false"><path fill="currentColor" d="M1 1l10 6-10 6z"/></svg>';
        thumbnail.appendChild(play);
      });
    });
  };

  const replaceHomepageHiddenHeading = () => {
    if (window.location.pathname !== '/') return;
    const heading = document.querySelector('#header-component h1.visually-hidden');
    if (!heading) return;
    const replacement = document.createElement('p');
    replacement.className = heading.className;
    replacement.textContent = heading.textContent;
    heading.replaceWith(replacement);
  };

  const decorateDynamicContent = () => {
    decorateCollection();
    decorateProductGallery();
  };

  const observeDynamicContent = () => {
    const root = document.querySelector('#MainContent');
    if (!root || root.dataset.mlCompatObserved === 'true') return;
    root.dataset.mlCompatObserved = 'true';

    let frame = 0;
    const observer = new MutationObserver((mutations) => {
      if (!mutations.some((mutation) => mutation.addedNodes.length || mutation.removedNodes.length)) return;
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        frame = 0;
        decorateDynamicContent();
      });
    });

    observer.observe(root, { childList: true, subtree: true });
  };

  const apply = () => {
    ensureStickyStyles();
    decorateDynamicContent();
    replaceHomepageHiddenHeading();
    observeDynamicContent();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply, { once: true });
  } else {
    apply();
  }

  document.addEventListener('shopify:section:load', apply);
  window.addEventListener('pageshow', apply);
})();
